import { lazy } from 'react';
const DeactivePO = lazy(() => import('../DeactivePO/DeactivePO.jsx'));

const DeactivePORoutes = [
  {
    path: '/deactivepo',
    component: DeactivePO
  }
];

export default DeactivePORoutes;
